<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <div class="hamburger-container">
      <div v-if="roleRenon == 0" style="color: #6e7c7c;font-weight: bold;height:60px;border-bottom:1px solid black;">Agent Level </div>
      <!-- <div v-if="role == 2" style="font-weight: bold;height:60px;border-bottom:1px solid black;">Factory</div> -->
      <div v-if="role == 2" style="color: #6e7c7c;font-weight: bold;height:60px;border-bottom:1px solid black;">Administrator</div>
      <div v-if="role == 3" style="color: #6e7c7c;font-weight: bold;height:60px;border-bottom:1px solid black;">Company Admin</div>
      <div v-if="role == 4" style="color: #6e7c7c;font-weight: bold;height:60px;border-bottom:1px solid black;">Installer</div>
    </div>
    <!-- <breadcrumb class="breadcrumb-container"/> -->
    <div style="float: left;display: flex;align-items: center;height: 100%;margin-left: 20px" v-if="env == 'development' || env == 'newmode'">
      <!-- 导出RENON设备数据备份 -->
      <el-button type="primary" @click="oneGet()" v-if="roleRenon == 0||role == 1">{{username}}设备</el-button>
      <el-button type="primary" @click="secGet()" v-if="role == 2">{{username}}设备</el-button>
      <el-button type="primary" @click="getSubUser()" v-if="roleRenon == 0||role == 1 || role == 2">{{username}}用户</el-button>
    </div>
    <div class="right-menu">

      <!--      <el-tooltip content="可视化大屏" effect="dark" placement="bottom"  :hide-after=2000  ref="visual" style="margin-right: 20px" v-if="hasPermission(1)">-->
      <!--          <svg-icon icon-class="visual" class="right-menu-item hover-effect" style="font-size: 50px;color: #000;" @click="handleToDP"></svg-icon>-->
      <!--      </el-tooltip>-->


      <!-- <div @click="handleRefresh"  class="refresh">
        Rerfesh
      </div> -->
      <div>
        <!-- Serial Number -->
        <!-- <el-select v-model="value" filterable placeholder="请选择" size="small" @change="handleChange">
          <el-option label="HE_BAT" value="HE_BAT"> </el-option>
        </el-select> -->
      </div>

      <div style="width: 10px"></div>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img src="http://fnjkj.oss-cn-beijing.aliyuncs.com/images1/1610160882887.png" class="user-avatar">
          <div style="width: 10px"></div>
          <div class="user-name">{{username}}</div>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">

          <el-dropdown-item>
            <span style="display:block;" @click="handleUpdatePwd">Password</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span style="display:block;" @click="logout">Log out</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span style="display:block;" @click="handleToAccount">Account</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <update-pwd ref="updatePwd"></update-pwd>
  </div>

</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'
  import UpdatePwd from './UpdatePwd'
  import {
    setLoginData,
    setJwt,
    getLoginData
  } from '@/utils/auth'
  import {
    logout
  } from '@/services/user'
  import {
    downloadThingsFile
  } from "@/services/device";
  import {
    downloadUsersCsvFile
  } from "@/services/subusers";
  import {
    getRoleId,
    getRoleIdRenon,
    getUserName
  } from "@/utils/auth"
  import FileSaver from "file-saver";
  import moment from "moment";
  export default {
    // name:NavbarInstall,
    components: {
      Breadcrumb,
      Hamburger,
      UpdatePwd
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'avatar',
        'name'
      ])
    },
    data() {
      return {
        list: [],
        value: "HE_BAT",
        role: '',
        username: "",
        roleRenon: "",
        env: ''
      }
    },
    mounted() {
      this.env = process.env.NODE_ENV;
      // this.loadData();
      this.role = getRoleId()
      this.roleRenon = getRoleIdRenon()
      let userName = getLoginData().user_name;
      if(userName.indexOf(this.$ident) != -1){
        this.username = getLoginData().user_name.replace(new RegExp(`^${this.$ident}`),'');
      } else {
        this.username = userName;
      }
    },
    methods: {
      handleToAccount() {
        this.$router.replace({
          path: '/endUserPage/personalInformation/index'
        })
      },
      handleRefresh() {
        this.$store.dispatch('deviceSelect/setDevice', "");
        this.$nextTick(() => {
          this.$store.dispatch('deviceSelect/setDevice', this.value);
        })
      },
      handleChange(value) {
        console.log(value);
        this.$store.dispatch('deviceSelect/setDevice', value);
      },
      // async loadData() {
      //   const res = await findDevList2({
      //     current_page: 1,
      //     page_size: 9999,

      //   });
      //   if (res) {
      //     this.list = res.data;
      //     // this.download(this.list);
      //   }
      //   this.$store.dispatch('deviceSelect/setDevList', this.list);
      // },
      //导出设备数据（Excel）
      async oneGet() {
        const loadingMsg = this.$message({ message: 'Exporting, please wait ..', type: 'info', duration: 0 });
        try {
          const res = await downloadThingsFile();
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const fileName = `${this.username}_dev_${moment().format("YYYY-MM-DD")}.xlsx`;
          FileSaver.saveAs(blob, fileName);
          loadingMsg.close();
          this.$message.success('Export successful');
        } catch (e) {
          loadingMsg.close();
          this.$message.error('Export failed. Please try again later');
        }
      },
      async secGet() {
        const loadingMsg = this.$message({ message: 'Exporting, please wait ..', type: 'info', duration: 0 });
        try {
          const res = await downloadThingsFile();
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const fileName = `${this.username}_dev_${moment().format("YYYY-MM-DD")}.xlsx`;
          FileSaver.saveAs(blob, fileName);
          loadingMsg.close();
          this.$message.success('Export successful');
        } catch (e) {
          loadingMsg.close();
          this.$message.error('Export failed. Please try again later');
        }
      },
      // 导出用户数据（CSV）
      async getSubUser() {
        const loadingMsg = this.$message({ message: 'Exporting, please wait ..', type: 'info', duration: 0 });
        try {
          const res = await downloadUsersCsvFile();
          const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
          const fileName = `${this.username}_user_${moment().format("YYYY-MM-DD")}.csv`;
          FileSaver.saveAs(blob, fileName);
          loadingMsg.close();
          this.$message.success('Export successful');
        } catch (e) {
          loadingMsg.close();
          this.$message.error('Export failed. Please try again later');
        }
      },
      handleToDP() {
        let routeUrl = this.$router.resolve({
          path: "/dashboard/operation"
        });
        window.open(routeUrl.href, "_blank");
      },
      handleUpdatePwd() {
        this.$refs.updatePwd.show();
      },
      toggleSideBar() {
        this.$store.dispatch('app/toggleSideBar')
      },
      async logout() {
        await logout()
        setLoginData("");
        setJwt('');
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .refresh {
    cursor: pointer;
    margin-right: 20px;
  }

  .navbar {
    height: 100px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

    .hamburger-container {
      line-height: 100px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background .3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .right-menu {
      float: right;
      height: 100%;
      line-height: 100px;
      display: flex;

      &:focus {
        outline: none;
      }

      .el-tooltip:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;

          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {

          position: relative;
          display: flex;
          justify-content: center;
          cursor: pointer;

          .user-avatar {

            width: 40px;
            height: 40px;
            border-radius: 10px;
            margin-top: 30px;
          }

          .user-name {
            margin-left: 10px;
            font-size: 16px;
            color: #6e7c7c;
            margin-top: -2px;
            font-weight: 500;
          }

          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
